@if (!isHidden) {
<div [ngModelGroup]="inputGroupName" [attr.selenium-name]="field()">
    <div class="layout-row" (keydown)="onKeydown($event)">
        @if (hasLeftSpacer) {
        <div fxHide fxShow.gt-sm class="spacer-left" [ngStyle]="{'width': spacerWidth}">
        </div>
        }
        @if (isFrontIconButton) {
        <metadata-icon-button [formRepository]="datacontroller!" [metadataModel]="metadataModel" [parent]="parent"
            [propertyMetadata]="propertyMetadata" (onValueChanged)="onValueChanged($event)" [viewOnly]="viewOnly()"
            [front]="true" class="no-focus {{IconClass}}" [dense]="dense()">
        </metadata-icon-button>
        }
        @if (isFrontTextButton) {
        <metadata-text-button [formRepository]="datacontroller!" [metadataModel]="metadataModel" [parent]="parent"
            [propertyMetadata]="propertyMetadata" (onValueChanged)="onValueChanged($event)" [viewOnly]="viewOnly()"
            [front]="true" class="no-focus" [dense]="dense()"
            [ngClass]="{'dense-input': dense() || compact(), 'full-width' : isFullWidth}">
        </metadata-text-button>
        }
        @if (isRichText) {
        <metadata-rich-text [model]="model" [metadataModel]="metadataModel" [parent]="parent"
            [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" (onValueChanged)="onValueChanged($event)"
            [label]="Label">
        </metadata-rich-text>
        }
        @if (includeContainer) {
        <div class="metadata-input-container flex" [ngClass]="{'dense-input': dense() || compact()}">
            <div [ngClass]="containerClasses" flex attr.telemetry="Edit-{{Label}}">
                @if (inputType === 'Text' || inputType === 'password') {
                <metadata-input-text [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [dense]="dense()"
                    [forCellEdit]="forCellEdit()" class="no-focus" (onValueChanged)="onValueChanged($event)"
                    [hint]="Hint" [error]="errorMessage" [compact]="compact()" [showSpinner]="showSpinner">
                </metadata-input-text>
                }
                @if (inputType === 'TextArea') {
                <metadata-input-text-area [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [dense]="dense()"
                    [forCellEdit]="forCellEdit()" class="no-focus" (onValueChanged)="onValueChanged($event)"
                    [hint]="Hint" [error]="errorMessage" [compact]="compact()" [showSpinner]="showSpinner">
                </metadata-input-text-area>
                }
                @if (inputType === 'Photo') {
                <metadata-photo [model]="model" [metadata]="propertyMetadata" [parent]="metadataModel"
                    [name]="propertyMetadata.Name" [viewOnly]="viewOnly()" class="no-focus" [dense]="dense()"
                    [isMenu]="isMenu()" fxLayout="column" (onValueChanged)="onValueChanged($event)"
                    fxLayoutAlign="start center">
                </metadata-photo>
                }
                @if (inputType === 'TypeAhead' || inputType === 'Select') {
                <metadata-input-typeahead [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()"
                    (onValueChanged)="onValueChanged($event)" class="no-focus" [dense]="dense()"
                    [forCellEdit]="forCellEdit()" [error]="errorMessage" [compact]="compact()"
                    [isSelect]="inputType === 'Select'">
                </metadata-input-typeahead>
                }
                @if (inputType === 'MultiSelect') {
                <metadata-input-multi-select [model]="model" [metadataModel]="metadataModel"
                    [datacontroller]="datacontroller!" [parent]="parent" [propertyMetadata]="propertyMetadata"
                    [viewOnly]="viewOnly()" [dense]="dense()" [forCellEdit]="forCellEdit()" class="no-focus"
                    (onValueChanged)="onValueChanged($event)" [hint]="Hint" [index]="index()" [compact]="compact()">
                </metadata-input-multi-select>
                }
                @if (inputType === 'DualList') {
                <metadata-input-dual-list [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [dense]="dense()"
                    [forCellEdit]="forCellEdit()" class="no-focus" (onValueChanged)="onValueChanged($event)"
                    [hint]="Hint" [index]="index()" [compact]="compact()">
                </metadata-input-dual-list>
                }
                @if (inputType === 'Date') {
                <metadata-input-date [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [dense]="dense()"
                    [forCellEdit]="forCellEdit()" class="no-focus" (onValueChanged)="onValueChanged($event)"
                    [hint]="Hint" [error]="errorMessage" [compact]="compact()" [showSpinner]="showSpinner">
                </metadata-input-date>
                }
                @if (inputType === 'DateTime') {
                <metadata-input-date-time [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [dense]="dense()"
                    [forCellEdit]="forCellEdit()" class="no-focus" (onValueChanged)="onValueChanged($event)"
                    [hint]="Hint" [error]="errorMessage" [compact]="compact()" [showSpinner]="showSpinner">
                </metadata-input-date-time>
                }
                @if (inputType === 'Check') {
                <metadata-input-checkbox [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [datacontroller]="datacontroller!" [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()"
                    [dense]="dense()" [forCellEdit]="forCellEdit()" class="no-focus"
                    (onValueChanged)="onValueChanged($event)" [hint]="Hint" [compact]="compact()">
                </metadata-input-checkbox>
                }
                @if (isNumeric || inputType === 'Currency' || inputType === 'Percent') {
                <metadata-input-number [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [dense]="dense()"
                    [forCellEdit]="forCellEdit()" class="no-focus" [compact]="compact()"
                    (onValueChanged)="onValueChanged($event)" [hint]="Hint" [error]="errorMessage"
                    [showSpinner]="showSpinner">
                </metadata-input-number>
                }
                @if (inputType === 'FilePicker') {
                <metadata-input-file [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()"
                    (onValueChanged)="onValueChanged($event)" [compact]="compact()" [label]="Label">
                </metadata-input-file>
                }
                @if (inputType ==='Color') {
                <metadata-input-color [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()"
                    (onValueChanged)="onValueChanged($event)" [compact]="compact()" [label]="Label">
                </metadata-input-color>
                }
                @if (inputType === 'Time' || inputType === 'Time24') {
                <metadata-input-time [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [dense]="dense()"
                    [time24Hour]="inputType === 'Time24'" [forCellEdit]="forCellEdit()" class="no-focus"
                    (onValueChanged)="onValueChanged($event)" [hint]="Hint" [error]="errorMessage" [compact]="compact()"
                    [showSpinner]="showSpinner">
                </metadata-input-time>
                }
                @if (inputType === 'PhoneNumber') {
                <metadata-input-phone-number [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [dense]="dense()"
                    [forCellEdit]="forCellEdit()" class="no-focus" (onValueChanged)="onValueChanged($event)"
                    [hint]="Hint" [error]="errorMessage" [allowExtension]="false" [compact]="compact()"
                    [showSpinner]="showSpinner">
                </metadata-input-phone-number>
                }
                @if (inputType === 'PhoneNumberWithExtension') {
                <metadata-input-phone-number [model]="model" [metadataModel]="metadataModel" [parent]="parent"
                    [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [dense]="dense()"
                    [forCellEdit]="forCellEdit()" class="no-focus" (onValueChanged)="onValueChanged($event)"
                    [hint]="Hint" [error]="errorMessage" [allowExtension]="true" [compact]="compact()"
                    [showSpinner]="showSpinner">
                </metadata-input-phone-number>
                }
            </div>
        </div>
        }
        @if ((allowAdd || allowEdit)) {
        <metadata-generic-button [model]="model" [forCellEdit]="forCellEdit()" [formRepository]="datacontroller!"
            [metadataModel]="metadataModel" [parent]="parent" [propertyMetadata]="propertyMetadata"
            (onValueChanged)="onValueChanged($event)" [viewOnly]="viewOnly()" [front]="false" class="no-focus"
            [dense]="dense()">
        </metadata-generic-button>
        }
        @if (isLabel) {
        <metadata-label [label]="Label" [compact]="compact()" [propertyMetadata]="propertyMetadata" class="no-focus"
            [dense]="dense()" [style.width]="width" [style.textAlign]="alignment">
        </metadata-label>
        }
        @if (isLabelValue) {
        <metadata-label-value [metadataModel]="metadataModel" [parent]="parent" [model]="model"
            [propertyMetadata]="propertyMetadata" [compact]="compact()" [dense]="dense()" [isMenu]="isMenu()"
            [label]="Label" [formattedModel]="formattedModel" fxFlex>
        </metadata-label-value>
        }
        @if (isHeader) {
        <metadata-header [label]="Label" [propertyMetadata]="propertyMetadata" class="no-focus">
        </metadata-header>
        }
        @if (isSpatialMap) {
        <metadata-spatial-map [model]="model" [parent]="parent" [metadataModel]="metadataModel"
            [formRepository]="datacontroller!" [propertyMetadata]="propertyMetadata" fxFlex="100">
        </metadata-spatial-map>
        }
        @if (isCalendar) {
        <metadata-calendar [model]="model" [parent]="parent" [metadataModel]="metadataModel"
            [formRepository]="datacontroller!" [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()"
            fxFlex="100">
        </metadata-calendar>
        }
        @if (isMonthCalendar) {
        <metadata-calendar-month [model]="model" [parent]="parent" [metadataModel]="metadataModel"
            [formRepository]="datacontroller!" [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()"
            fxFlex="100">
        </metadata-calendar-month>
        }
        @if (isChart) {
        <metadata-chart fxFlex="auto" [model]="model" (valueChanged)="onValueChanged($event)">
        </metadata-chart>
        }
        @if (isScript) {
        <metadata-script fxFlex="auto" [model]="model"></metadata-script>
        }
        @if (isHtml) {
        <metadata-html fxFlex="auto" [model]="model" class="no-focus">
        </metadata-html>
        }
        @if (isLink) {
        <metadata-link [formRepository]="datacontroller!" [metadataModel]="metadataModel" [parent]="parent"
            [propertyMetadata]="propertyMetadata" [viewOnly]="viewOnly()" [compact]="compact()" [front]="false"
            class="no-focus {{IconClass}}" [dense]="dense()">
        </metadata-link>
        }
        @if (isBadge) {
        <metadata-badge [propertyMetadata]="propertyMetadata" [model]="model" [formattedModel]="formattedModel" fxFlex>
        </metadata-badge>
        }
        @if (isInlineMessage ) {
        <metadata-inline-message [propertyMetadata]="propertyMetadata" [model]="model" [formattedModel]="formattedModel"
            fxFlex>
        </metadata-inline-message>
        }
        @if (isTree) {
        <metadata-tree fxFlex>
        </metadata-tree>
        }
        @if (isBackIconButton) {
        <metadata-icon-button [formRepository]="datacontroller!" [metadataModel]="metadataModel" [parent]="parent"
            [propertyMetadata]="propertyMetadata" (onValueChanged)="onValueChanged($event)" [viewOnly]="viewOnly()"
            [front]="false" class="no-focus {{IconClass}}" [dense]="dense()" [compact]="compact()" style="height:auto;"
            [forCellEdit]="forCellEdit()">
        </metadata-icon-button>
        }
        @if (!isLink && isBackTextButton) {
        <metadata-text-button [formRepository]="datacontroller!" [metadataModel]="metadataModel" [parent]="parent"
            [propertyMetadata]="propertyMetadata" (onValueChanged)="onValueChanged($event)" [viewOnly]="viewOnly()"
            [dense]="dense()" [front]="false" class="no-focus"
            [ngClass]="{'dense-input': dense() || compact(), 'full-width' : isFullWidth}" [compact]="compact()">
        </metadata-text-button>
        }
        @if (hasRightSpacer) {
        <div class="spacer-right" fxHide fxShow.gt-sm [ngStyle]="{'width': spacerWidth}">
        </div>
        }
    </div>
</div>
}